import {Component, ElementRef, ViewChild} from '@angular/core';
import {IonicPage, NavController, NavParams, Platform} from 'ionic-angular';
import {Camera, CameraOptions} from "@ionic-native/camera";
import {environment} from "../../environments/environment";
import {HttpClient} from "@angular/common/http";
import { LoadingController } from 'ionic-angular';
import {WareneingangPage} from "../wareneingang/wareneingang";

/**
 * Generated class for the ReklamationPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-reklamation',
  templateUrl: 'reklamation.html',
  providers: []
})
export class ReklamationPage {

  pv;

  images = {};
  @ViewChild('upload') upload: ElementRef;

  imgKey: any;


  constructor(public navCtrl: NavController, public navParams: NavParams, private camera: Camera, public http: HttpClient, public loadingCtrl: LoadingController, public platform: Platform) {
    this.pv = this.navParams.get('pv');
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ReklamationPage');
  }

  takeOrUploadImage(img_key) {
    if (this.platform.is('android')) {
      //this.takeImage(img_key);
    } else {
      // this.uploadImage(img_key);
    }
    this.imgKey = img_key;
    this.upload.nativeElement.click();
  }

  takeImage(img_key) {
    const options: CameraOptions = {
      quality: 80,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      targetWidth: 2048,
      targetHeight: 1536
    };
    this.camera.getPicture(options).then((imageData) => {
      // imageData is either a base64 encoded string or a file URI
      // If it's base64 (DATA_URL):
      this.images[img_key] = 'data:image/jpeg;base64,' + imageData;
    });
  }

  uploadImage(img_key) {
    const options: CameraOptions = {
      quality: 80,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      targetWidth: 2048,
      targetHeight: 1536
    };
    this.camera.getPicture(options).then((imageData) => {
      // imageData is either a base64 encoded string or a file URI
      // If it's base64 (DATA_URL):
      this.images[img_key] = 'data:image/jpeg;base64,' + imageData;
    });
  }

  checkSenden() {
    return false;
    /*if (this.images['zaehlliste'] !== undefined) {
      return false;
    }
    return true;*/
  }

  senden() {
      const loader = this.loadingCtrl.create({
        content: "Bitte warten...",
      });
      loader.present();

    const body = {
      token: localStorage.getItem('token'),
      module: 'orders',
      submodule: 'reklamation',
      pv: this.pv,
      images: this.images,
    };
    const sub = this.http.post(environment.api_url, body).subscribe(daten => {
      loader.dismiss();
      this.navCtrl.setRoot(WareneingangPage);
      alert('Bilder wurden gesendet');
      sub.unsubscribe();
      }, error => {
        loader.dismiss();
        alert('Bilder konnten nicht gesendet werden.');
      }
    );
  }

  fileChangeEvent(event: any): void {
    console.log(event);

    const file:File = event.target.files[0];
    console.log(file);

    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = async () => {
        await this.resizeImage(reader.result as string).then((resolve: any) => {
          this.images[this.imgKey] = resolve;
        });
      };
    }
  }

  resizeImage(imageURL: any): Promise<any> {
    return new Promise((resolve) => {
      const image = new Image();
      image.onload = function () {
        const width = image.width;
        const height = image.height;
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        if (ctx != null) {
          ctx.drawImage(image, 0, 0, width, height);
        }
        var data = canvas.toDataURL('image/jpeg', 0.8);
        resolve(data);
      };
      image.src = imageURL;
    });
  }


}




// WEBPACK FOOTER //
// ./src/pages/reklamation/reklamation.ts